import { Stack, styled } from '@mui/material';

export const AuthCardStyled = styled(Stack)(({ theme }) => ({
  width: 656,
  borderRadius: theme.spacing(1),
  background: theme.palette.white.main,
  padding: theme.spacing(4),
  gap: theme.spacing(2),
}));
